import { render } from "./CoursesSidebar.vue?vue&type=template&id=2e958dfc&scoped=true"
import script from "./CoursesSidebar.vue?vue&type=script&lang=js"
export * from "./CoursesSidebar.vue?vue&type=script&lang=js"

import "./CoursesSidebar.vue?vue&type=style&index=0&id=2e958dfc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e958dfc"]])

export default __exports__